export default __webpack_public_path__ + "static/media/img19.71f07162.webp";